module.exports = __webpack_public_path__ + "img/WebDesign.1755d465.svg";